export default __webpack_public_path__ + "img/destinys_ball.png";